import T1 from '@rategravity/frontend/theme/webfonts/TiemposHeadline-Medium.eot';
import T2 from '@rategravity/frontend/theme/webfonts/TiemposHeadline-Medium.eot?#iefix';
import T5 from '@rategravity/frontend/theme/webfonts/TiemposHeadline-Medium.ttf';
import T4 from '@rategravity/frontend/theme/webfonts/TiemposHeadline-Medium.woff';
import T3 from '@rategravity/frontend/theme/webfonts/TiemposHeadline-Medium.woff2';

export const Tiempos = {
  src: `url(${T1}), url(${T2}), url(${T3}), url(${T4}), url(${T5})`
};
